<template>
    <span id="minimum-detail">
        <i class="el-icon-search header-info-dialog-value icon-action" id="btn-appointments-detail"
       @click="dialogVisible = true" size="mini" icon="el-icon-plus"></i>
        <el-dialog
        id="appointments-detail-dialog"
        :visible.sync="dialogVisible"
        width="70%"
        :title=dialogTitle
        :close-on-click-modal="false"
        append-to-body
    >
        <el-row :gutter="20" class="row-spacing">
            <el-col :span="20">
              <span class="title-list">{{ $t('customerCenter.appointments.appointmentInformationTitle') }}</span>
            </el-col>
          </el-row>

        <el-row>
            <el-col :span="6" class="form-vertical-item">
                <div class="label-value-pair">
                    <label class="span-small-list dos-label">{{ $t('customerCenter.appointments.loadNumber') }}</label>
                    <span class="span-small-list">{{ appointment.loadNumber }}</span>
                </div>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="6" class="form-vertical-item">
                <div class="label-value-pair">
                    <label class="span-small-list dos-label">{{ $t('customerCenter.appointments.shipDate') }}</label>
                    <span class="span-small-list">{{ formatDate(appointment.shipDate) }}</span>
                </div>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="6" class="form-vertical-item">
                <div class="label-value-pair">
                    <label class="span-small-list dos-label">{{ $t('customerCenter.appointments.account') }}</label>
                    <span class="span-small-list">{{ appointment.accountName }} - {{ appointment.accountNumber }}</span>
                </div>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="6" class="form-vertical-item">
                <div class="label-value-pair">
                    <label class="span-small-list dos-label">{{ $t('customerCenter.appointments.appointmentDate') }}</label>
                    <span v-if="appointment.fcfs">
                        {{ formatDate(appointment.appointmentStartDate) }} - {{ formatDate(appointment.appointmentEndDate) }}
                    </span>
                    <span v-else>
                        {{ formatDate(appointment.appointmentStartDate) }}
                    </span>
                </div>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="6" class="form-vertical-item">
                <div class="label-value-pair">
                    <label class="span-small-list dos-label">{{ $t('customerCenter.appointments.appointmentTime') }}</label>
                    <span v-if="appointment.fcfs">
                        {{ appointment.appointmentStartTime }} - {{ appointment.appointmentEndTime }}
                    </span>
                    <span v-else>
                        {{ appointment.appointmentStartTime }}
                    </span>
                </div>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="6" class="form-vertical-item">
                <div class="label-value-pair">
                    <label class="span-small-list dos-label">{{ $t('customerCenter.appointments.note') }}</label>
                    <span class="span-small-list">{{ appointment.note }}</span>
                </div>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="6" class="form-vertical-item">
                <div class="label-value-pair">
                    <label class="span-small-list dos-label">{{ $t('customerCenter.appointments.hub') }}</label>
                    <span class="span-small-list">{{ appointment.hub }}</span>
                </div>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="6" class="form-vertical-item">
                <div class="label-value-pair">
                    <label class="span-small-list dos-label">{{ $t('customerCenter.appointments.operator') }}</label>
                    <span class="span-small-list">{{ appointment.operator }}</span>
                </div>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="6" class="form-vertical-item">
                <div class="label-value-pair">
                    <label class="span-small-list dos-label">{{ $t('customerCenter.appointments.notificationStatus') }}</label>
                    <el-tag :type="appointment.sent === true ? 'success' : (appointment.sent === false ? 'danger' : 'info')">
                        {{ appointment.sent === true ? 'Sent' : (appointment.sent === false ? 'Failed' : 'Pending') }}
                    </el-tag>
                </div>
            </el-col>
        </el-row>

        <!--System Information-->
        <el-row :gutter="20" class="row-spacing">
            <el-col :span="20">
              <span class="title-list">{{ $t('customerCenter.appointments.systemInformation') }}</span>
            </el-col>
          </el-row>

        <el-row>
            <el-col :span="6" class="form-vertical-item">
                <div class="label-value-pair">
                    <label class="span-small-list dos-label">{{ $t('customerCenter.appointments.createdBy') }}</label>
                    <span class="span-small-list">{{ formatUser(appointment.createdByUsername) }}</span>
                </div>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="6" class="form-vertical-item">
                <div class="label-value-pair">
                    <label class="span-small-list dos-label">{{ $t('customerCenter.appointments.createdTime') }}</label>
                    <span class="span-small-list">{{ formatAuditDate(appointment.auditCreationDate) }}</span>
                </div>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="6" class="form-vertical-item">
                <div class="label-value-pair">
                    <label class="span-small-list dos-label">{{ $t('customerCenter.appointments.lastModifiedBy') }}</label>
                    <span class="span-small-list">{{ formatUser(appointment.lastUpdatedByUsername) }}</span>
                </div>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="6" class="form-vertical-item">
                <div class="label-value-pair">
                    <label class="span-small-list dos-label">{{ $t('customerCenter.appointments.lastUpdatedDate') }}</label>
                    <span class="span-small-list">{{ formatAuditDate(appointment.auditLastUpdate) }}</span>
                </div>
            </el-col>
        </el-row>

        </el-dialog>


    </span>
    </template>

<script>
import moment from 'moment';

export default {
  name: 'DetailAppointment',
  props: {
    appointment: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialogVisible: false,
      appointmentDetaiTitle: this.$t('customerCenter.appointments.detailTitle')
    };
  },
  computed: {
    dialogTitle() {
      return this.appointment.loadNumber !== null
        ? `${this.$t('customerCenter.appointments.detailTitle')} - ${this.appointment.loadNumber}`
        : this.$t('customerCenter.appointments.detailTitle');
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      const m = moment(date);
      if (!m.isValid()) return '';
      return m.format('MM/DD/YYYY');
    },
    formatAuditDate(date) {
      if (!date) return '-';
      if (typeof date === 'string') {
        if (/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/.test(date)) return date;
        const alt = moment(date, ['MM/DD/YYYY HH:mm:ss', 'MM-DD-YYYY HH:mm:ss', 'YYYY-MM-DD HH:mm:ss', moment.ISO_8601], true);
        if (alt.isValid()) return alt.format('MM/DD/YYYY HH:mm:ss');
        const loose = moment(date);
        if (loose.isValid()) return loose.format('MM/DD/YYYY HH:mm:ss');
        return '-';
      }
      const m = moment(date);
      if (!m.isValid()) return '-';
      return m.format('MM/DD/YYYY HH:mm:ss');
    },
    formatUser(user) {
      return user !== null ? user : '-';
    }
  }
};
</script>

<style>
.label-value-pair {
  display: grid;
  grid-template-columns: 200px auto;
  align-items: center;
}
.label-value-pair span {
  white-space: nowrap;
  overflow: visible;
  text-overflow: unset;
}

.form-vertical-item {
  margin-bottom: 16px;
}


</style>
